import React from 'react'
import About from '../components/About';
import Ourteam from '../components/Ourteam';
import Happycustomer from '../components/Happycustomer';
import Ourmission from '../components/Ourmission';

export default function Aboutus() {
  return (
    <>
      <About />
      <Ourmission />
      <Ourteam />
      <Happycustomer />
    </>
  )
}
